import { Statistic } from 'models/dashboard';
import { parseDiagnosisResult } from './translateDiagnosis';
import { translateTnoName } from './prepareTno';

export const prepareDiagnosisTno = (
  data: {
    key: string;
    statistics: Statistic[];
  }[]
) => {
  const ret: { data: any[]; keys: Set<string> } = { data: [], keys: new Set() };

  for (const t of data) {
    const tno: any = {};
    tno.id = parseDiagnosisResult(t.key);

    for (const c of t.statistics) {
      const name = translateTnoName(c.name);
      tno[name] = c.quantity;
      ret.keys.add(name);
    }

    ret.data.push(tno);
  }

  return ret;
};
